import React from 'react'
import { Link } from 'react-router-dom'
import { noop } from '../helpers'

function Logo({ logo }) {
  return (
    <Link id={'header-logo-link'} to={'/'}>
      <img id={'header-logo'} src={logo} alt={'FOAM'} />
    </Link>
  )
}

function ExternalHeaderLink({ href, text }) {
  return (
    <a className={'header-link'} target={'_blank'} href={href}>
      {text}
    </a>
  )
}
function HeaderText({ text }) {
  return <span className={'header-link'}>{text}</span>
}

function InternalHeaderLink({ href, text, selected, selectedColor }) {
  return (
    <Link className={'header-link'} to={href}>
      {text}
      {selected ? <hr style={{ backgroundColor: selectedColor }} /> : null}
    </Link>
  )
}

function ExternalFooterLink({ href, text }) {
  return (
    <a className={'footer-link'} target={'_blank'} href={href}>
      {text}
    </a>
  )
}

function InternalFooterLink({ href, text }) {
  return (
    <Link className={'footer-link'} to={href}>
      {text}
    </Link>
  )
}

function ExternalCTA({ href, text, isNew }) {
  const newClassName = isNew ? 'isNew' : ''
  return (
    <a
      className={`cta cta--external ${newClassName}`}
      target={'_blank'}
      href={href}
    >
      {text}
    </a>
  )
}

function ExternalImageCTA({ href, text, onClickHandler }) {
  return (
    <a
      className={`cta-image`}
      target={'_blank'}
      href={href}
      onClick={onClickHandler}
    >
      {text}
    </a>
  )
}
function InternalImageCTA({ href, text, onClickHandler }) {
  return (
    <Link className={`cta-image`} to={href} onClick={onClickHandler}>
      {text}
    </Link>
  )
}

function ExternalButtonCTA({ href, text, onClickHandler }) {
  return (
    <a
      className={`cta-button`}
      target={'_blank'}
      href={href}
      onClick={onClickHandler}
    >
      {text}
    </a>
  )
}

function InternalCTA({ href, text, isNew }) {
  const newClassName = isNew ? 'isNew' : ''
  return (
    <Link className={`cta ${newClassName}`} to={href}>
      {text}
    </Link>
  )
}

function PlaintextCTA({ href, text, isNew }) {
  const newClassName = isNew ? 'isNew' : ''
  return <span className={`cta-plaintext ${newClassName}`}>{text}</span>
}

function addCTAs(list) {
  list = Array.isArray(list) ? list : [list]
  return list.map((li, idx) => {
    const isNew = li.new ? true : false
    switch (li.type) {
      case 'INTERNAL':
        return (
          <InternalCTA
            key={`cta-${idx}`}
            href={li.path}
            text={li.text}
            isNew={isNew}
          />
        )
      case 'EXTERNAL':
        return (
          <ExternalCTA
            key={`cta-${idx}`}
            href={li.path}
            text={li.text}
            isNew={isNew}
            onClickHandler={li.onClickHandler || noop}
          />
        )
      case 'EXTERNAL-BUTTON':
        return (
          <ExternalButtonCTA
            key={`cta-${idx}`}
            href={li.path}
            text={li.text}
            onClickHandler={li.onClickHandler || noop}
          />
        )
      case 'EXTERNAL-IMAGE':
        return (
          <ExternalImageCTA
            key={`cta-${idx}`}
            href={li.path}
            text={li.text}
            onClickHandler={li.onClickHandler || noop}
          />
        )
      case 'INTERNAL-IMAGE':
        return (
          <InternalImageCTA
            key={`cta-${idx}`}
            href={li.path}
            text={li.text}
            onClickHandler={li.onClickHandler || noop}
          />
        )
      case 'PLAINTEXT':
        return <PlaintextCTA key={`cta-${idx}`} text={li.text} />
      default:
        return null
    }
  })
}

function parseLinksFooter(routes, key) {
  const filterer = r => r.category === key
  const filteredToCategory = routes.reduce((acc, r) => {
    const route = filterer(r) ? [r] : []
    const childRoutes = r.children == null ? [] : r.children.filter(filterer)
    return acc.concat(route, childRoutes)
  }, [])
  const seen = {}
  const deduped = filteredToCategory.reduce((acc, r) => {
    if (seen[r.name]) {
      return acc
    } else {
      seen[r.name] = true
      return acc.concat(r)
    }
  }, [])
  return deduped.map(r => {
    switch (r.type) {
      case 'INTERNAL-NORMAL':
        return (
          <InternalFooterLink key={`f-${r.path}`} href={r.path} text={r.name} />
        )
      case 'EXTERNAL-NORMAL':
        return (
          <ExternalFooterLink key={`f-${r.path}`} href={r.path} text={r.name} />
        )
      case 'EXTERNAL-BUTTON':
        return (
          <ExternalFooterLink key={`f-${r.path}`} href={r.path} text={r.name} />
        )
      default:
        return null
    }
  })
}

function parseLinksHeader(routes, currentRoute) {
  const routeMapper = (r, idx) => {
    switch (r.type) {
      case 'INTERNAL-NORMAL':
        return (
          <InternalHeaderLink
            key={idx}
            href={r.path}
            text={r.name}
            selected={currentRoute != null && r.path === currentRoute.path}
            selectedColor={r.selectedColor}
          />
        )
      case 'EXTERNAL-NORMAL':
        return <ExternalHeaderLink key={idx} href={r.path} text={r.name} />
      case 'TEXT':
        return <HeaderText key={idx} text={r.name} />
      default:
        return null
    }
  }
  return routes.map((r, idx) => {
    const res = routeMapper(r, idx)
    if (res == null) {
      return null
    }
    return (
      <div className="HeaderLinkWrapper" key={`HeaderLinkWrapper-Root-${idx}`}>
        {res}
        {r.children && (
          <div className="HeaderLinkWrapper-dropDown">
            {r.children.map((r_, idx_) => routeMapper(r_, idx_))}
          </div>
        )}
      </div>
    )
  })
}

export {
  Logo,
  InternalHeaderLink,
  ExternalHeaderLink,
  ExternalFooterLink,
  InternalFooterLink,
  ExternalCTA,
  ExternalButtonCTA,
  ExternalImageCTA,
  InternalCTA,
  PlaintextCTA,
  addCTAs,
  parseLinksHeader,
  parseLinksFooter
}



// WEBPACK FOOTER //
// ./src/Components/Links.js